import { buildCollectionPath } from '@repo/config';
import { Link } from '@repo/web-chrome/components/link';
import { CollectionPoster } from './collection-poster';

interface ICollectionCardProps {
  slug: string;
  title: string;
  posterUrl: string | null | undefined;
  titleInPoster?: number;
  challengeCount?: number;
  countLabel?: string;
  parentTitle?: string | null;
  badgeLabel?: string;
  footerLabel?: string;
}

export function CollectionCard({
  slug,
  title,
  posterUrl,
  titleInPoster,
  challengeCount,
  countLabel,
  parentTitle,
  badgeLabel,
  footerLabel,
}: ICollectionCardProps): React.JSX.Element {
  return (
    <Link
      href={buildCollectionPath(slug)}
      className="cm-zoom cm-lift group relative block aspect-2/3 rounded-2xl bg-muted hover:shadow-xl"
    >
      <CollectionPoster
        title={title}
        posterUrl={posterUrl}
        titleInPoster={titleInPoster}
        challengeCount={challengeCount}
        countLabel={countLabel}
        parentTitle={parentTitle}
        badgeLabel={badgeLabel}
        footerLabel={footerLabel}
      />
    </Link>
  );
}
